"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _errors = _interopRequireDefault(require("../errors"));
/**
 * This validation chck if the last four digits of the account number selected in Plaid matches the
 * account number the user has entered in the text box
 * @param  {string} value - user entered value
 * @param  {string} field - name of the field
 * @param  {object} model - Data Model used for validation
 */
var lastFour = function lastFour(value, field, model) {
  if (field === 'accountNumber' || field === 'confirmAccountNumber') {
    var lastFourEntered = value;
    var lastFourSelected = model.selectedAccount.lastFour;
    if (value.length >= 4) {
      lastFourEntered = value.substring(value.length - 4);
    }
    if (lastFourSelected !== lastFourEntered) {
      return "".concat(_errors["default"][field].lastFour, " ").concat(model.selectedAccount.lastFour, ".");
    }
  }
  return false;
};
var _default = lastFour;
exports["default"] = _default;
